'use strict';

/*@ngInject*/
module.exports = function () {
    return {
        scope: {
            object: '=',
            classifiers: '=',
            features: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        /*@ngInject*/
        controller: function controller(publicObjectsService, $scope, $uibModal) {
            var vm = this;
            vm.showModal = false;

            $scope.$watch(function () {
                return vm.showModal;
            }, function (newVal, oldVal) {
                if (!newVal) {
                    vm.features = vm.getFeatures();
                }
            });

            vm.$onInit = function () {
                return vm.features = vm.getFeatures();
            };

            vm.getFeatures = function () {
                var features = [];
                angular.forEach(vm.classifiers.properties, function (feature) {
                    if (vm.object.version.features.includes(feature.id)) {
                        var foundFeature = _.find(features, function (f) {
                            return f.path === feature.icon_path;
                        });
                        if (!foundFeature) {
                            features.push({ path: feature.icon_path, name: feature.name });
                        }
                    }
                });
                return features;
            };

            vm.showFeaturesModal = function () {
                vm.showModal = true;
            };

            vm.openFeaturesModal = function () {
                var modalInstance = $uibModal.open({
                    template: require('./objects-edit-features-modal.html'),
                    controller: require('./objects-edit-features-modal.directive'),
                    controllerAs: 'vm',
                    size: 'lg',
                    backdrop: 'static',
                    keyboard: false,
                    windowClass: 'center-modal',
                    resolve: {
                        data: function data() {
                            return { object: vm.object, features: vm.object.version.features, classifiers: vm.classifiers.properties };
                        }
                    }
                });

                modalInstance.result.then(function (features) {
                    vm.object.version.features = features;
                    vm.features = vm.getFeatures();
                });
            };
        },

        template: require('./objects-edit-features.html')
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/objects/edit/directives/objects-edit-features.directive.js
 **/